import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloudOff, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

/* PILOTO-1C (firma #81) — EL TERCER ESTADO DE LAS DOS PANTALLAS DE PROFESOR.
 *
 * EL HUECO QUE CIERRA. Hasta hoy, «no pude leer» y «no tienes nada» se pintaban
 * igual: `GroupsPage` cazaba el error, hacía `setGroups([])` y el usuario leía
 * «Todavía no tienes grupos» — una frase FALSA y, para un profesor que acaba de
 * repartir un código, alarmante. `GroupDetailPage` hacía lo contrario y no
 * salía del esqueleto: quedaba cargando para siempre. Los dos casos estaban
 * declarados en reporte_piloto1.md y se cierran aquí.
 *
 * POR QUÉ UN COMPONENTE Y NO DOS BLOQUES: son la misma situación en dos
 * pantallas. Con el bloque copiado, el copy o el tap target de uno se habrían
 * desviado del otro en el primer retoque — que es exactamente lo que le pasó al
 * manejo de errores que esto viene a reemplazar.
 *
 * LA FACTURA VISUAL ES LA DEL EMPTY STATE que ya existe (indicación de Carlos):
 * misma tarjeta `glass-card`, mismo redondeo, mismo aire, icono al centro,
 * título en `#a0a0a0` y pie en `#555`. Lo único que suma es el botón, y es un
 * PRIMARIO de verdad: el naranja insignia `#FF6B00`, el mismo de «Nuevo grupo»
 * — no un link gris que se lee como decoración. 44 pt de alto, centrado.
 *
 * SAFE AREAS: ninguna. Vive dentro del scrollport de `AppLayout`, que ya lleva
 * el inset de arriba y el colchón de abajo; escribir otro aquí contaría el
 * notch dos veces (lección firmada en Analytics.js:737).
 */

/* t7-3 remate 8 (#591, C13 y C89): dos props OPCIONALES para el panel "Avance del grupo": `titulo` (su propio aviso) y
 * `sinRed` (la frase de "se cayo la conexion" solo cuando de verdad no hubo respuesta). Sin ellas, lo de siempre: las
 * otras pantallas que lo usan no cambian. */
export default function GroupsLoadError({ onRetry, testid = 'groups-error', titulo, sinRed = true }) {
  const { t } = useTranslation(['dashboard']);
  return (
    <div className="glass-card rounded-[20px] p-8 md:p-12 text-center" data-testid={testid}>
      <CloudOff className="w-10 h-10 text-[#333] mx-auto mb-4" />
      <p className="text-sm text-[#a0a0a0]">{titulo || t('dashboard:groups.load_error_title')}</p>
      {sinRed && <p className="text-xs text-[#a0a0a0] mt-2 max-w-md mx-auto">{t('dashboard:groups.load_error_hint')}</p>}
      <Button
        onClick={onRetry}
        className="mt-6 bg-[#FF6B00] hover:bg-[#E05A00] text-white rounded-xl min-h-[44px] px-5 text-sm"
        data-testid={`${testid}-retry`}>
        <RefreshCw className="w-4 h-4 mr-2" /> {t('dashboard:groups.retry_btn')}
      </Button>
    </div>
  );
}
